import { useCallback, useEffect, useState } from 'react';
import { PricingEnum } from '../enums/pricingEnum';
import { Plan } from '../interfaces/catalog.interface';
import { getCatalogo } from '../services/catalogo.service';

type Ipricing = { loading: true, planMap: undefined } | { loading: false, planMap: Map<string, Plan> };

export const usePricing = (): (key: PricingEnum) => { value: string, parcel: string, parcelValue: string } => {
  const [value, setValue] = useState<Ipricing>({ loading: true, planMap: undefined });

  useEffect(() => {
    (async function() {
      try {
        const response = await getCatalogo();
        const map = new Map<string, Plan>();
        response.plans.forEach(element => {
          map.set(element.business_name, element);
        });
        setValue({ loading: false, planMap: map });
      } catch (error) {
        console.error('Failed to fetch catalog pricing', error);
      }
    })();
  }, []);

  return useCallback((key: PricingEnum) => {
    if (value.loading) {
      return {
        value: '',
        parcel: '',
        parcelValue: ''
      };
    }

    const plan = value.planMap.get(key);

    if (!plan) {
      return {
        value: '',
        parcel: '',
        parcelValue: ''
      };
    }

    const format = (value: number) => {
      const formato = new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });

      return formato.format(value);
    };

    return {
      value: format(Number(plan.price)),
      parcel: String(plan.max_installments),
      parcelValue: format(Number(plan.price) / plan.max_installments)
    };
  }, [value]);
};
